<template>
  <b>{{ mensaje || "No hay datos para mostrar." }}</b>
</template>

<script setup>
const { mensaje } = defineProps({
  mensaje: { type: String, required: true },
});
</script>
